import { UserType } from "@istari/istari-client";

import type { InternalUserType } from "~/api/user/user";

const ZITADEL_PROVIDER_NAME = "zitadel";
const REGISTRY_ID_PATTERN = /^[0-9a-f]{8}(-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i;

export function isRegistryAgentId(id: string | null | undefined): id is string {
  return !!id && REGISTRY_ID_PATTERN.test(id);
}

export function isLegacyZitadelAgent(user: InternalUserType): boolean {
  return (
    user.userType === UserType.Agent &&
    user.providerName === ZITADEL_PROVIDER_NAME &&
    !isRegistryAgentId(user.providerUserId) &&
    !user.principalId
  );
}
